import React, { useMemo } from 'react'
import logo from 'images/logo.png'
import c from './LogoLoader.module.scss'

interface LogoLoaderProps {
  className?: string
}

function LogoLoader({ className = undefined }: LogoLoaderProps) {
  const classNames = useMemo(() => {
    let result = c.loader
    if (className) result += ` ${className}`
    return result
  }, [className])

  return (
    <div className={classNames}>
      <div className={c.content}>
        <img className={c.logo} src={logo} alt="Logo" />
        <p className={c.text}>Retomagic</p>
      </div>
    </div>
  )
}

export default LogoLoader
